export default "__VITE_ASSET__DYngzHCw__"